import { useAsync } from 'react-async-hook'
import { getPlans } from './PaymentService'

export function usePlans() {
  return useAsync(getPlans, [])
}

